// src/utils/storage.js
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";

/** Sube un dataURL a Storage y regresa su downloadURL */
async function uploadDataUrl(storageUid, dataUrl) {
  const storage = getStorage();
  // Detecta extensión según el mime del dataURL (png/jpg/webp/svg…)
  const match = /^data:(image\/[a-zA-Z0-9.+-]+);base64,/.exec(dataUrl);
  const ext = match ? match[1].split("/")[1].replace("+xml", "") : "jpg";
  const name = `${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;

  // ← volvemos al path que sí cubren tus reglas actuales
  const objectRef = ref(storage, `productosClientes/${storageUid}/${name}`);

  await uploadString(objectRef, dataUrl, "data_url");
  return await getDownloadURL(objectRef);
}

/** Si value es dataURL la sube; si ya es URL (http/https/gs://), la deja igual */
export async function uploadIfDataUrl(storageUid, value) {
  if (!value) return null;
  if (typeof value === "string" && value.startsWith("data:image")) {
    return await uploadDataUrl(storageUid, value);
  }
  return value; // ya es URL pública o gs://
}

/**
 * Normaliza imágenes de un producto:
 * - Si vienen en base64, las sube y reemplaza por URLs
 * - Mantiene el resto de propiedades del objeto
 * @param {Object} data - Objeto de producto con imagen/imagenes.
 * @param {string} storageUid - UID del usuario autenticado que SUBE (request.auth.uid).
 */
export async function normalizeImages(data, storageUid) {
  const list =
    Array.isArray(data.imagenes) && data.imagenes.length
      ? data.imagenes
      : data.imagen
      ? [data.imagen]
      : [];

  const urls = await Promise.all(
    list.filter(Boolean).map((v) => uploadIfDataUrl(storageUid, v))
  );

  return {
    ...data,
    imagenes: urls,
    imagen: urls[0] || null,
  };
}
